exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".errors li[data-v-aed0d4d6] {\n  margin-bottom: 1rem;\n}\n.errors strong[data-v-aed0d4d6] {\n  display: block;\n  margin-bottom: 0.5rem;\n  font-weight: 500;\n}", ""]);

// exports
